import { graphql } from '@/gql';

graphql(`
  fragment MailOptionsFragment on MailOptionResponse {
    gourmetRestaurantsMail
    monthlyInvoiceMail
    reactivationPostcardsMail
    happyBirthdayPostcardsMail
  }
`);
